import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { GetUserKYCsRespond } from './types/Kyc';

export type Query = {
  limit?: number;
  offset?: number;
};

export type GetUserKYCs = (
  userId: 'me' | number,
  query?: Query,
) => Promise<{ data: GetUserKYCsRespond }>;

export default (makeCall: MakeCall): GetUserKYCs => (userId = 'me', query) =>
  makeCall<GetUserKYCsRespond>('GET', `${APIV2_URL}/user/${userId}/kyc`, {
    query,
  });
